module.exports = __webpack_public_path__ + "163af018.svg";